import * as Yup from "yup";
import { FormControl } from "../../_components/Forms/FormControl";
import { FormModal } from "../../_components/Forms/FormModal";

export function ServicesForm({ onSubmit, defaultValues, isUpdate }) {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Nazwa jest wymagana").max(100, "Nazwa nie może mieć więcej niż 100 znaków"),
  });

  const formControls = (
    <>
      <FormControl label="Nazwa" name="name" autoFocus/>
    </>
  );

  const buttonText = isUpdate ? "Edytuj usługę" : "Dodaj usługę";
  const successMessage = isUpdate ? "Zaktualizowano usługę" : "Dodano usługę";

  return (
    <>
      <FormModal
        formControls={formControls}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        buttonText={buttonText}
        successMessage={successMessage}
        title={buttonText}
        defaultValues={defaultValues}
        btnSize="small"
      />
    </>
  );
}